import api from "../api";
import {ElMessage} from "element-plus";

export default {
    namespaced: true,
    state: {
        ticket_channels: {data: [], current_page: 1, total: 0, per_page: 10},
        errors: {
            data: {
                errors: {}
            }
        },
        has_errors: false,
        loading: false,
        dialogVisible: false,
    },
    getters: {
        dialogVisible: state => state.dialogVisible,
        loading: state => state.loading,
        ticket_channels: state => state.ticket_channels,
        errors: state => state.errors,
        has_errors: state => state.has_errors,
    },
    mutations: {
        setDialogVisible(state, status) {
            state.dialogVisible = status;
        },
        setLoading(state, data) {
            state.loading = data;
        },
        setTicketChannels(state, data) {
            state.ticket_channels = data;
        },
        setErrors(state, errors) {
            state.errors = errors
        },
        hasErrors(state, val) {
            state.has_errors = val
            if (!val) {
                state.errors = {
                    data: {
                        errors: {}
                    }
                };
            }
        }
    },
    actions: {
        openDialogVisible({commit}, status) {
            commit('setDialogVisible', status);
        },
        async getTicketChannels({commit}, filters) {
            commit('setLoading', true);
            try {
                const response = await api.getTicketChannels(filters);
                commit('setTicketChannels', response);
                commit('setLoading', false);
            } catch (e) {
                ElMessage.error(e.response.data.message);
                commit('setLoading', false);
            }
        },

        async createTicketChannels({dispatch, commit}, data) {
            try {
                commit('hasErrors', false)
                await api.createTicketChannels(data);
                ElMessage.success('ticket channel created successfully!');
                commit('setDialogVisible', false)
                dispatch('getTicketChannels', {
                    paginate: true
                })
            } catch (e) {
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error('Error creating ticket channel!');
            }
        },
        async editTicketChannels({dispatch, commit}, data) {
            try {
                await api.editTicketChannel(data);
                ElMessage.success('ticket channel updated successfully!');
                commit('setDialogVisible', false)
                dispatch('getTicketChannels', {
                    paginate: true
                })
            } catch (e) {
                ElMessage.error('Error updating ticket channel');
            }
        },
        async deleteTicketChannels({commit, dispatch}, data) {
            commit('setLoading', true);
            try {
                const response = await api.deleteTicketChannel(data);
                commit('setLoading', false);
                dispatch('getTicketChannels', {
                    paginate: true
                })
                if (response.status === 401) {
                    ElMessage.warning({
                        message: response.message,
                        duration: 10000
                    });
                } else {
                    ElMessage.success({
                        message: response.message,
                        duration: 10000
                    });
                }
            } catch (e) {
                ElMessage.error(e.response.data.message);
                commit('setLoading', false);
            }
        },

    }
}
